/*
 * ******************************************************************
 * Copyright (c) 2022-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Component, Input, Output } from "@angular/core";
import { Subject } from "rxjs";
import { NavUtils } from "@shared/utils/nav-utils";

export enum ErrorMessageType {
    ERROR,
    WARNING,
    HELP_INFO
}
//@formatter:off
@Component({
    standalone: false,
    selector: 'error-msg',
    templateUrl: 'error-msg.component.html',
    styleUrls: ['error-msg.component.scss']
})
//@formatter:on
export class ErrorMsgComponent {

    ErrorMessageType = ErrorMessageType;

    @Input()
    type: ErrorMessageType = ErrorMessageType.ERROR;

    @Input()
    show: boolean = false;

    @Input()
    errorMsg: string;

    @Input()
    errorBtn: string;

    @Input()
    errorBtnDisabled: boolean;

    @Output()
    errorBtnClick: Subject<void> = new Subject<void>();

    @Input()
    errorLoading: boolean;

    @Input()
    errorLoadingMsg: string;

    @Input()
    helpInfoBtn: string;

    @Input()
    helpInfoUrl: string;

    onErrorButtonClick(): void {
        this.errorBtnClick.next();
    }

    showHelpInfo(): void {
        if (this.helpInfoUrl) {
            NavUtils.openExternalLink(this.helpInfoUrl);
        }
    }
}
